import api from "../utils/api";

export const getBookings = async (params) => {
  try {
    const response = await api.get("/bookings", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching bookings:", error);
    throw error;
  }
};

export const getBookingById = async (id) => {
  try {
    const response = await api.get(`/bookings/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching booking with id ${id}:`, error);
    throw error;
  }
};

export const createBooking = async (bookingData) => {
  try {
    const response = await api.post("/bookings", bookingData);
    return response.data;
  } catch (error) {
    console.error("Error creating booking:", error);
    throw error;
  }
};

export const updateBooking = async (id, bookingData) => {
  try {
    const response = await api.put(`/bookings/${id}`, bookingData);
    return response.data;
  } catch (error) {
    console.error(`Error updating booking with id ${id}:`, error);
    throw error;
  }
};

export const deleteBooking = async (id) => {
  try {
    const response = await api.delete(`/bookings/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting booking with id ${id}:`, error);
    throw error;
  }
};

export const getAvailability = async (date, location) => {
  try {
    const response = await api.get(`/bookings/availability`, { params: { date, location } });
    return response.data;
  } catch (error) {
    console.error("Error fetching availability:", error);
    throw error;
  }
};


export const getBookingsByPlace = async (placeId, params) => {
  try {
    console.log("Fetching bookings for place ID:", placeId);
    const response = await api.get(`/bookings/place/${placeId}`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching bookings for place ${placeId}:`, error);
    throw error;
  }
};
export const getBookingsByUserIdAndPlaceId = async (userId, placeId, params) => {
  try {
    const response = await api.get(`/bookings/user/${userId}/place/${placeId}`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching bookings for user ${userId} and place ${placeId}:`, error);
    throw error;
  }
};


export const triggerEndCharge = async (id) => {
  try {
    const response = await api.post(`/bookings/trigger_end_charge/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error triggering end of charge for booking ${id}:`, error);
    throw error;
  }
};

export const updateBookingCost = async (id, cost) => {
  try {
    const response = await api.put(`/bookings/${id}/cost`, { total_cost: cost });
    return response.data;
  } catch (error) {
    console.error(`Error updating cost for booking ${id}:`, error);
    throw error;
  }
};
